/**
 * One status list for every order table, status menu, and detail screen.
 *
 * Keep the English values identical to the API enum. Keep the Arabic labels
 * for the dashboard only.
 *
 * THE ORDER IS THE ORDER'S LIFE (api#145): the restaurant's steps, then the
 * driver's, then the two ends that stop it. `in the way` means on the way to
 * the customer, so the pickup comes before it. The menus read top to bottom
 * in the order an operator expects the order to move.
 *
 * `legacy` marks a status that the dashboard no longer offers. It keeps its
 * label, so a row that carries it still reads correctly, but it is not offered
 * in a menu or a filter — see ORDER_STATUS_CHOICES.
 */
export const ORDER_STATUSES = [
    { en: "not started", ar: "لم يبدأ", color: "#6c757d" },
    { en: "preparing", ar: "قيد التحضير", color: "#ffc107" },
    { en: "finished", ar: "انتهى التحضير", color: "#28a745" },
    { en: "in the way", ar: "في الطريق", color: "#007bff" },
    { en: "complete", ar: "اكتمل", color: "#20c997" },
    { en: "cancel", ar: "مرفوض", color: "#dc3545" },
    { en: "deleted", ar: "تم المسح", color: "#343a40" },
    // Nothing writes `started`, and no order in the production copy carries it.
    { en: "started", ar: "تم البدء", color: "#17a2b8", legacy: true },
    // Out of the menus at the owner's request (2026-09-27). In the corrected
    // flow of api#145, the pickup is the move to `in the way`. Until the flag
    // flip, driver build 5 still sends `picked up` for «استلمت من المطعم», so a
    // row may carry it: the label stays, and the «جارية» filter still counts it.
    { en: "picked up", ar: "استلمه السائق", color: "#6f42c1", legacy: true },
];

/** The statuses a menu or a filter offers: every one that is not legacy. */
export const ORDER_STATUS_CHOICES = ORDER_STATUSES.filter((status) => !status.legacy);
